import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AlertsContainer from '../state/AlertsContainer';
import CurrentUserContainer from '../state/CurrentUserContainer';

export const useEmailPreferences = () => {
    const { t } = useTranslation();
    const alertsContainer = AlertsContainer.useContainer();
    const currentUserContainer = CurrentUserContainer.useContainer();
    const [isEmailOptIn, setIsEmailOptIn] = useState(currentUserContainer.currentUser?.isEmailOptIn ?? false);

    const handleSaveEmailPreferences = async () => {
        try {
            const result = await currentUserContainer.updateEmailPreferences({ isEmailOptIn });
            if (result?.resultType === 'Ok') {
                alertsContainer.showSuccess(t('common:account.success.marketing'));
            } else {
                alertsContainer.showError(result?.errors?.join(', ') ?? t('common:account.error.marketing'));
            }
        } catch (error) {
            console.error('Failed to update email preferences:', error);
            alertsContainer.showError(t('common:account.error.generic'));
        }
    };

    return { isEmailOptIn, setIsEmailOptIn, handleSaveEmailPreferences };
};
